import { cartObserver } from '../../../_helpers/cart-observer';

export default function () {
    cartObserver.subscribe((cart) => {
        // Update the cart total numbers
        Array.from(document.querySelectorAll('[data-cart-total]')).forEach((el) => {
            const total = cart.items.reduce((total, item) => total + item.quantity, 0);
            el.innerText = total;

            el.classList.toggle('empty', total === 0);
        });
    });
}
